import { Button, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ProjectTimeline from './ProjectTimeline'



const ProjectList = () => {
  const dateData = useSelector(state => state.dateData)
  const data = useSelector(state => state.rawData)
  const selectedDate = useSelector(state => state.chooseWeek)
  const selectedItems = useSelector(state => state.chooseItem)
  const itemGroup = useSelector(state => state.chooseItemGroup)


  const [modalItem, setModalItem] = useState("")
  const [open, setOpen] = useState(false)

  const handleOpen = (item) => {
    setOpen(true)
    setModalItem(item)
  }

  const handleClose = () => {
    setOpen(false)
  }


  const [itemsUsedInTimePeriod, setItemsUsedInTimePeriod] = useState([])

  useEffect(() => {
    const temp = []
    Object.keys(dateData.value).map((date) => {
      const currentDate = new Date(dateData.value[date].datum)
      currentDate.setHours(0,0,0,0)

      if (currentDate >= selectedDate.value.from && currentDate <= selectedDate.value.to) {
        if (!temp.includes(dateData.value[date].tariefomschrijving)) {
          temp.push(dateData.value[date].tariefomschrijving)
        }
      }
    })
    setItemsUsedInTimePeriod(temp)
  }, [dateData, selectedDate])

  


  return (
    <div>
        <h2>Projecten tijdlijn</h2>
        <h3>Per tarief</h3>
        {Object.keys(selectedItems.value).map((itemGroup) => {
          return Object.keys(selectedItems.value[itemGroup]).map((item, index) => {
            if (selectedItems.value[itemGroup][item] === true)
            return (
              <div key={index}>
                <Divider />
                <Button  
                  fullWidth = {true}
                  onClick={() => handleOpen(item)}
                  style={{textAlign: "left", justifyContent:"flex-start"}}
                  disabled={itemsUsedInTimePeriod.includes(item) ? false : true}
                  >{item}
                </Button>
              </div>
            )
          })
        })}
        <ProjectTimeline 
          item={modalItem}
          open={open} 
          handleClose={handleClose}
        />
    </div>
  )
}

export default ProjectList